/* eslint-disable react-refresh/only-export-components */
import { createContext, useContext } from "react";

type WidgetContextType = Record<string, never>;

const WidgetContext = createContext<WidgetContextType | null>(null);

const WidgetProvider = ({ children }: { children: React.ReactNode }) => {
  return <WidgetContext.Provider value={{}}>{children}</WidgetContext.Provider>;
};

const useWidgetProvider = () => {
  const context = useContext(WidgetContext);
  if (!context) {
    throw new Error("useWidgetProvider must be used within a WidgetProvider");
  }
  return context;
};

export { WidgetProvider, useWidgetProvider };
